/**
 * Utility functions for user input validation and security checks.
 */

/**
 * Checks if a username contains terms or patterns that could be used for phishing or impersonation
 * (such as system admin terms, brand names, or visual spoofing patterns).
 */
export function checkUsernameForPhishing(username: string): { isValid: boolean; error?: string } {
  const normalized = username.toLowerCase().trim();

  if (!normalized) {
    return { isValid: false, error: 'O nome de usuário não pode estar vazio.' };
  }

  // 1. Normalize visual homoglyphs and leetspeak patterns to prevent bypass attempts
  // For example: 'c4rdumy', 'adm1n', 'sup0rte', 'cardurny'
  let canonical = normalized;
  
  // Replace characters often used for visual deception
  canonical = canonical.replace(/[1l!|]/g, 'i');
  canonical = canonical.replace(/[0]/g, 'o');
  canonical = canonical.replace(/[4@]/g, 'a');
  canonical = canonical.replace(/[3]/g, 'e');
  canonical = canonical.replace(/[5$]/g, 's');
  canonical = canonical.replace(/[7]/g, 't');
  canonical = canonical.replace(/[v]/g, 'u');
  canonical = canonical.replace(/rn/g, 'm');

  // Strip all non-alphanumeric characters to detect obfuscated words like "c-a-r-d-u-m-y" or "su.por.te"
  const stripped = canonical.replace(/[^a-z0-9]/g, '');

  const phishingTerms = [
    'cardumy',
    'cardumi',
    'cardymy',
    'admin',
    'administrador',
    'administrator',
    'suporte',
    'support',
    'moderador',
    'moderator',
    'system',
    'sistema',
    'oficial',
    'official',
    'staff',
    'atendimento',
    'gerente',
    'manager',
    'security',
    'seguranca',
    'helpdesk',
    'suport'
  ];

  for (const term of phishingTerms) {
    if (normalized.includes(term) || canonical.includes(term) || stripped.includes(term)) {
      return {
        isValid: false,
        error: `Nome de usuário indisponível! Termos administrativos, variações de marcas ou palavras associadas ao suporte da plataforma não podem ser utilizados para evitar falsificação de identidade (phishing).`
      };
    }
  }

  // 2. Additional regex checks for suspicious prefix/suffix structures typically used by scammers
  const suspiciousPrefixes = [/^adm[0-9i_.-]/i, /^sup[0-9o_.-]/i, /^card[0-9_.-]/i];
  for (const regex of suspiciousPrefixes) {
    if (regex.test(normalized)) {
      return {
        isValid: false,
        error: 'Nome de usuário indisponível devido a regras rígidas de segurança contra fraudes e clonagem de contas.'
      };
    }
  }

  return { isValid: true };
}
